import type { Dict } from "../core.js";
import type { appLinks as vi } from "../vi/appLinks.js";

export const appLinks: Dict<typeof vi> = {
  title: "App links",
  intro:
    "App Link links between bube-shop and bube-banktransfer, seen from the bt side. Customers have no screen for this on the bt dashboard — staff handle incidents by hand. Each side can change only ITS OWN intent: here you change bt's intent only; bube-shop's intent is read-only.",
  refresh: "Reload",
  loading: "Reading links…",
  loadFailed: "Could not read the App Link links from bube-banktransfer.",
  empty: "bube-banktransfer has no App Link links yet.",
  truncated: "Showing only the {limit} most recently created links.",
  writeOnly: "Requires bube-banktransfer write permission to suspend, disconnect or resend.",
  unknownCompany: "(company name unavailable)",
  "field.company": "Company (bt tenant)",
  "field.peer": "Other side",
  "field.lifecycle": "Effective state",
  "field.localIntent": "bt's intent",
  "field.peerIntent": "{peer}'s intent",
  "field.peerIntentNone": "no confirmation received",
  "field.branches": "Bound branches",
  "field.health": "Health",
  "field.deliveries": "Deliveries",
  "field.lastError": "Last error",
  "field.probe": "Last successful check of the other side",
  "field.noError": "none",
  "field.never": "never",
  "intent.revision": "rev {n} · {at}",
  "lifecycle.pending": "Being set up",
  "lifecycle.active": "Active",
  "lifecycle.suspended": "Suspended",
  "lifecycle.disconnected": "Disconnected",
  "intent.active": "On",
  "intent.suspended": "Suspended",
  "intent.disconnected": "Disconnected",
  "health.unknown": "Unknown",
  "health.healthy": "Healthy",
  "health.degraded": "Degraded",
  "health.error": "Error",
  "reason.never_synced": "Never synced.",
  "reason.capabilities_unknown": "Unknown which event types the other side supports — waiting for a capability check.",
  "reason.intent_unconverged": "An intent change is waiting to be delivered to the other side.",
  "reason.delivery_lagging": "A business delivery has been waiting for over 15 minutes.",
  "reason.delivery_unsupported": "The other side does not accept the event type of some deliveries yet.",
  "reason.delivery_dead_letter": "Some deliveries ran out of retries and are no longer sent automatically — use « Resend ».",
  "reason.delivery_failing": "Deliveries keep failing.",
  "reason.sync_failing": "Structure sync keeps failing.",
  "reason.sync_behind": "Structure is behind the other side.",
  "reason.branches_unbound": "The other side pushed branches that bt has not bound.",
  "reason.apply_failed": "bt rejected the other side's latest structure revision.",
  "deliveries.pending": "Waiting {n}",
  "deliveries.held": "Held {n}",
  "deliveries.unsupported": "Not accepted {n}",
  "deliveries.deadLetter": "Expired {n}",
  "deliveries.none": "nothing queued",
  "deliveries.hint":
    "Held = link not open so not sent (released automatically when it reopens) · Not accepted = the other side has not declared that event type · Expired = retries exhausted, only « Resend » returns them to the queue.",
  "action.suspend": "Suspend",
  "action.resume": "Resume",
  "action.disconnect": "Disconnect",
  "action.reconnect": "Reconnect",
  "action.redrive": "Resend {n} expired",
  "confirm.cancel": "Cancel",
  "confirm.busy": "Sending…",
  "confirm.failed": "Could not complete.",
  "confirm.title.suspend": "Suspend the link with {peer}?",
  "confirm.title.resume": "Resume the link with {peer}?",
  "confirm.title.disconnect": "Disconnect the link with {peer}?",
  "confirm.title.reconnect": "Reconnect the link with {peer}?",
  "confirm.title.redrive": "Resend {n} expired deliveries?",
  "confirm.scope": "Company {company} · link {link}. Changes bt's intent ONLY; {peer}'s intent stays as it is.",
  "confirm.effect.suspend.1": "Business traffic on the link stops: bt does not send money to {peer}; business deliveries are HELD (not lost).",
  "confirm.effect.suspend.2": "{peer} is told the intent changed and sees the link as suspended.",
  "confirm.effect.suspend.3": "Reversible at any time with « Resume ».",
  "confirm.effect.resume.1": "The link runs again only when BOTH sides are on — if {peer} is still suspended / disconnected the link stays stopped.",
  "confirm.effect.resume.2": "bt re-checks the other side's capabilities before releasing held deliveries.",
  "confirm.effect.disconnect.1": "The link is cut: pending business deliveries are DROPPED when the delivery tick reaches them (nothing is sent to {peer}).",
  "confirm.effect.disconnect.2": "{peer} is told the intent changed and sees the link as disconnected.",
  "confirm.effect.disconnect.3": "Reconnectable with « Reconnect », but dropped deliveries do not come back.",
  "confirm.effect.reconnect.1": "The link runs again only when BOTH sides are on — if {peer} is still suspended / disconnected the link stays stopped.",
  "confirm.effect.reconnect.2": "bt re-checks the other side's capabilities before releasing held deliveries.",
  "confirm.effect.redrive.1": "{n} expired deliveries return to the queue, their retry count resets to 0 and they are sent on the next tick.",
  "confirm.effect.redrive.2": "They still obey the link's rules: on a suspended / disconnected link they are held or dropped, never forced through.",
  "confirm.type": "Type the company name (or the link id if it has no name) to confirm:",
  "confirm.submit": "Confirm",
  "result.changed": "bt's intent is now « {intent} ». The link's new effective state: {lifecycle}.",
  "result.unchanged": "bt's intent is already in that state — nothing changed.",
  "result.redriven": "Requeued {n} deliveries.",
  "result.redrivenNone": "No expired deliveries left to resend.",
};
